import { AdminOrganization, AdminUserBase, PatchOperation } from '..';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace AdminActions {
  export class LoadOrganizations {
    static readonly type = '[ADMIN] Load Organizations';
  }

  export class LoadOverview {
    static readonly type = '[ADMIN] Load Overview';
  }

  export class LoadOrganization {
    static readonly type = '[ADMIN] Load Organization';
    constructor(public id?: string) {}
  }

  export class LoadUsers {
    static readonly type = '[ADMIN] Load Users';
  }

  export class LoadUser {
    static readonly type = '[ADMIN] Load User';
    constructor(public id?: string) {}
  }

  export class PatchOrganization {
    static readonly type = '[ADMIN] Patch Organization';
    constructor(
      public id: string,
      public patchOperations: PatchOperation[]
    ) {}
  }

  export class RemoveUserFromOrganization {
    static readonly type = '[ADMIN] Remove User From Organization';
    constructor(
      public user: AdminUserBase,
      public organization: AdminOrganization
    ) {}
  }

  export class DeleteUser {
    static readonly type = '[ADMIN] Delete User';
    constructor(
      public userId: string,
      public name: string
    ) {}
  }
}
